import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewProject.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import CheckBox from 'components/shared/checkbox/CheckBox';
import { loadBuildingsRequest } from 'actions/admin/work-orders/creation/buildings';
import { getBuildings } from 'selectors/admin/work-orders/work-orders';
import {
  getProjectForm,
  getShowNewBuildingModal,
} from 'components/admin/projects/creation/store/selectors';
import {
  setProjectFormValue,
  setShowNewBuildingModal,
} from 'components/admin/projects/creation/store/actions';
import NewBuildingModal from 'components/admin/projects/creation/NewBuildingModal';
import PropTypes from 'prop-types';

class BuildingSelection extends Component {
  static propTypes = {
    submitButtonLabel: PropTypes.string.isRequired,
    submitFunction: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(loadBuildingsRequest(this.props.projectForm.clientId));
  }

  handleProjectFormChange = (attribute, value) => {
    this.props.dispatch(setProjectFormValue(attribute, value));
  };

  showAddNewBuildingModal = () => {
    this.props.dispatch(setShowNewBuildingModal(true));
  };

  render() {
    return (
      <div>
        <div>
          <h3 className="selection-title">What property is the Project for?</h3>
          <input
            className={`btn button button-orange add-new-building-button`}
            type="button"
            value="Add New Building"
            onClick={this.showAddNewBuildingModal}
          />
        </div>

        <div className="selection-table-container">
          <SimpleTable
            headers={['', 'ADDRESS', 'BUILDING NAME']}
            rows={this.mapBuildings(this.props.buildings)}
            emptyMessage="No Buildings"
          />
        </div>

        {this.props.showNewProjectModal && <NewBuildingModal />}

        <input
          className={`btn button button-continue ${
            this.canContinue() ? 'button-orange' : 'button-disabled'
          }`}
          type="button"
          value={this.props.submitButtonLabel}
          onClick={this.props.submitFunction}
          disabled={!this.canContinue()}
        />
      </div>
    );
  }

  mapBuildings = (buildings) => {
    return buildings.map((building) => {
      return [
        <CheckBox
          id={building.id}
          checked={building.id === this.props.projectForm.buildingId}
          shape={'round'}
          size={'medium'}
          onChange={this.handleProjectFormChange.bind(this, 'buildingId')}
        />,
        <span className="h4">{`${building.location.street_address_1}, ${building.location.city}, ${building.location.state} ${building.location.zip}`}</span>,
        building.name || 'N/A',
      ];
    });
  };

  mapBuildingData = () => {
    const buildingForm = this.props.buildingForm;
    return {
      name: buildingForm.name,
      location: {
        streetAddress: buildingForm.streetAddress1,
        unitNumber: buildingForm.streetAddress2,
        city: buildingForm.city,
        state: buildingForm.state,
        zip: buildingForm.zip,
      },
      clientsId: [this.props.projectForm.clientId],
    };
  };

  canContinue = () => {
    return !!this.props.projectForm.buildingId;
  };
}

export default connect((state) => {
  return {
    buildings: getBuildings(state),
    projectForm: getProjectForm(state),
    showNewProjectModal: getShowNewBuildingModal(state),
  };
})(BuildingSelection);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/BuildingSelection.js